import { useEffect, useRef } from 'react';
export function usePathChangeEffect(targetPathname, _a) {
  var enter = _a.enter,
    leave = _a.leave,
    hashChange = _a.hashChange;
  var isActiveRef;
  var previousHashRef;
  if (typeof window !== 'undefined') {
    isActiveRef = useRef(window.location.pathname === targetPathname);
    previousHashRef = useRef(window.location.hash);
  }
  useEffect(function () {
    var handlePathAndHashChange = function () {
      var currentPath = window.location.pathname;
      var currentHash = window.location.hash;
      var isActive = isActiveRef === null || isActiveRef === void 0 ? void 0 : isActiveRef.current;
      // Handle entering or leaving the target path
      if (currentPath === targetPathname && !isActive) {
        if (enter) {
          enter();
        }
        isActiveRef.current = true;
      } else if (currentPath !== targetPathname && isActive) {
        if (leave) {
          leave();
        }
        isActiveRef.current = false;
      }
      // Handle hash change within the target path
      if (currentPath === targetPathname && hashChange && previousHashRef.current !== currentHash) {
        hashChange(currentHash);
      }
      // Update previous hash
      previousHashRef.current = currentHash;
    };
    // Initialize callback based on the current pathname and hash
    handlePathAndHashChange();
    // Override history methods to detect `pushState` and `replaceState` changes
    var originalPushState = window.history.pushState;
    var originalReplaceState = window.history.replaceState;
    var overrideHistoryMethod = function (method) {
      return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        method.apply(this, args);
        handlePathAndHashChange();
      };
    };
    window.history.pushState = overrideHistoryMethod(originalPushState);
    window.history.replaceState = overrideHistoryMethod(originalReplaceState);
    // Listen for popstate changes and hash changes
    window.addEventListener('popstate', handlePathAndHashChange);
    window.addEventListener('hashchange', handlePathAndHashChange);
    // Cleanup
    return function () {
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
      window.removeEventListener('popstate', handlePathAndHashChange);
      window.removeEventListener('hashchange', handlePathAndHashChange);
    };
  }, [targetPathname, enter, leave, hashChange]);
}